import type { SettingsNode } from '~/shared/api/settings-api';

export const SETTINGS_MODULE_LABEL: Record<SettingsNode['module'], string> = {
  club: 'Клуб',
  operations: 'Операции',
  'pricing-loyalty': 'Цены и лояльность',
  communications: 'Коммуникации',
  integrations: 'Интеграции',
  'access-security': 'Доступ и безопасность',
  system: 'Система',
  fitness: 'Фитнес',
};
